import {
	FeatureIslandCategoryContext,
	useFeatureIslandCategoryManagerContext,
} from "@/components/features/_layouts/island/main-with-category/context";

import { Dot } from "@/components/ui/dot";

import { FeatureIslandCategorySideMenuItemForMain } from "./components";

export type SideMenuTitleArrayType = {
	base: Readonly<
		{
			title: Readonly<string>;
			isShow: Readonly<boolean>;
		}[]
	>;
	additional: Readonly<
		{
			title: Readonly<string>;
			isShow: Readonly<boolean>;
		}[]
	>;
};

export const FeatureIslandCategorySideMenuForMain = () => {
	const basicSetupItems = useFeatureIslandCategoryManagerContext((state) => state.basicSetupItems);
	const nonBasicSetupItems = useFeatureIslandCategoryManagerContext((state) => state.nonBasicSetupItems);
	const setActiveCategoryID = useFeatureIslandCategoryManagerContext((state) => state.setActiveCategoryID);

	const canShowAdditionalSetup = nonBasicSetupItems?.length > 0;

	return (
		<aside className="sticky top-32 h-full w-[230px] shrink-0">
			<div className="flex w-full flex-col gap-y-4">
				<div className="rounded-md border border-zinc-100 bg-white p-4 text-xs">
					<div className="flex items-center gap-x-1">
						<Dot />
						<p>：</p>
						<p>設定した項目がある</p>
					</div>

					<div className="flex items-center gap-x-1">
						<Dot variant="red" />
						<p>：</p>
						<p>未入力の項目がある</p>
					</div>
				</div>

				<div className="flex flex-col gap-y-4 rounded-md border border-zinc-100 bg-white p-4">
					<h5 className="select-none text-sm font-semibold">基本設定</h5>
					{basicSetupItems.map((item) => {
						const { categoryID } = item.getState();

						return (
							<FeatureIslandCategoryContext.Provider key={categoryID} value={item}>
								<FeatureIslandCategorySideMenuItemForMain onSetActiveCategoryID={setActiveCategoryID} />
							</FeatureIslandCategoryContext.Provider>
						);
					})}
					{canShowAdditionalSetup && (
						<>
							<h5 className="select-none text-sm font-semibold">追加設定</h5>
							{nonBasicSetupItems.map((item) => {
								const { categoryID } = item.getState();

								return (
									<FeatureIslandCategoryContext.Provider key={categoryID} value={item}>
										<FeatureIslandCategorySideMenuItemForMain
											onSetActiveCategoryID={setActiveCategoryID}
										/>
									</FeatureIslandCategoryContext.Provider>
								);
							})}
						</>
					)}
				</div>
			</div>
		</aside>
	);
};
